export default __webpack_public_path__ + "static/media/background-4.d394358d.svg";